<template>
  <div>
     <App-navigation></App-navigation>
     <v-container grid-list-lg>

     <v-layout row wrap>
       <v-flex xs12 sm12 md4 @click="nextPage('tickets-refreshment')">
        <v-card  class="text-xs-center display-3 font-weight-black my-5" >
                  
             <v-icon style="font-size:200px; " color="brown darken-4" dark>launch
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text" ><b></b></span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                </v-icon>

                    <v-card-title primary-title >
                        <div>
                            <h3 class="headline mb-0 "><b>Ticket Refreshment</b></h3>
                         </div>
                         </v-card-title>
           </v-card>
               
            </v-flex>
     
       <v-flex xs12 sm12 md4  @click="nextPage('tickets-staff')">
        <v-card  class="text-xs-center display-3 font-weight-black my-5" >
                  
             <v-icon style="font-size:200px;" color="brown darken-4" dark>person
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text" ><b></b></span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                </v-icon>

                    <v-card-title primary-title >
                        <div>
                            <h3 class="headline mb-0 "><b>Ticket Staff</b></h3>
                         </div>
                         </v-card-title>
           </v-card>
               
            </v-flex>
     
     <v-flex xs12 sm12 md4>
        <v-card  class="text-xs-center display-3 font-weight-black my-5" >
                  
             <v-icon style="font-size:200px;" color="brown darken-4" dark>people                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text" ><b></b></span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                </v-icon>

                    <v-card-title primary-title >
                        <div>
                            <h3 class="headline mb-0 "><b>Ticket Users</b></h3>
                         </div>
                         </v-card-title>
           </v-card>
               
            </v-flex>
     
            </v-layout>  
  
     </v-container>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
export default {
  name: 'ticket',
  data(){
      return {
          staff:this.$store.getters.getStaff,
      }
  },
  methods:{
nextPage(value){
    this.$router.push({ name:value });
}
},
  components: {
    AppNavigation,
  }
}
</script>
